import { render, staticRenderFns } from "./SetsSingle.vue?vue&type=template&id=1238fa2b&"
import script from "./SetsSingle.vue?vue&type=script&lang=js&"
export * from "./SetsSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports